import { useState, FormEvent } from 'react';
import { Link } from 'react-router-dom';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import Breadcrumb from '@/components/base/Breadcrumb';

export default function AboutPage() {
  return (
    <>
      <Navbar />
      <main className="pt-16">
        <div className="bg-background-50 border-b border-background-200/60">
          <div className="max-w-[1280px] mx-auto px-4 md:px-6">
            <Breadcrumb
              items={[
                { label: '首页', href: '/' },
                { label: '关于我们' },
              ]}
            />
          </div>
        </div>

        <AboutHero />
        <StatsSection />
        <TestimonialSection />
        <ContactSection />
        <FAQSection />
      </main>
      <Footer />
    </>
  );
}

function AboutHero() {
  const keywords = ['真实', '快速', '劲爆', '独家'];

  return (
    <section className="py-16 md:py-20 px-4 md:px-6 bg-background-50">
      <div className="max-w-[1280px] mx-auto flex flex-col items-center text-center">
        <h1 className="text-3xl md:text-5xl font-black text-foreground-950 font-heading leading-tight mb-4">
          吃瓜爆料网 <span className="text-primary-500">🍉</span>
        </h1>
        <p className="text-xl md:text-2xl font-bold text-foreground-800 font-heading mb-8">
          一手情报中心 <span className="text-accent-500">⚡</span>
        </p>

        <div className="flex flex-wrap items-center justify-center gap-3 md:gap-4 mb-8">
          {keywords.map((kw, idx) => (
            <span
              key={kw}
              className="px-5 py-2.5 bg-background-100 border border-background-200/60 rounded-lg text-sm font-bold text-foreground-700"
              style={{
                transform: `rotate(${idx === 0 ? -2 : idx === 3 ? 2 : 0}deg) translateY(${idx === 1 ? -4 : idx === 2 ? -4 : 0}px)`,
              }}
            >
              {kw}
            </span>
          ))}
        </div>

        <p className="text-sm md:text-base text-foreground-600 max-w-2xl mb-8">
          吃瓜爆料网成立于2020年，是国内领先的娱乐八卦资讯聚合平台。我们致力于为"吃瓜群众"提供最快、最准、最劲爆的明星塌房、网红翻车、反差视频等一手八卦情报。团队由资深娱乐记者、数据分析师和技术工程师组成，7×24小时全网监控，确保你不错过任何一个大瓜。
        </p>

        <div className="flex flex-col sm:flex-row items-center gap-3">
          <a href="#contact" className="px-6 py-3 bg-primary-500 hover:bg-primary-600 text-background-50 font-bold rounded-full text-sm transition-colors cursor-pointer whitespace-nowrap">
            联系合作
          </a>
          <Link
            to="/category/mingxing-tafang"
            className="px-6 py-3 text-foreground-600 hover:text-foreground-950 font-medium rounded-full text-sm transition-colors cursor-pointer whitespace-nowrap"
          >
            免责声明
          </Link>
        </div>
      </div>
    </section>
  );
}

function StatsSection() {
  return (
    <section className="py-12 md:py-16 px-4 md:px-6 bg-background-100">
      <div className="max-w-[1280px] mx-auto">
        <div className="flex flex-col lg:flex-row gap-8 md:gap-10">
          <div className="flex-1">
            <h2 className="text-2xl md:text-3xl font-black text-foreground-950 font-heading leading-tight mb-2">
              全网最强<br />吃瓜矩阵
            </h2>
            <div className="grid grid-cols-3 gap-4 mt-8 pt-6 border-t border-background-200/60">
              <div>
                <p className="text-2xl md:text-3xl font-black text-secondary-500">10000+</p>
                <p className="text-xs text-foreground-500 mt-1">独家爆料</p>
              </div>
              <div>
                <p className="text-2xl md:text-3xl font-black text-secondary-500">5000+</p>
                <p className="text-xs text-foreground-500 mt-1">高清视频</p>
              </div>
              <div>
                <p className="text-2xl md:text-3xl font-black text-secondary-500">24h</p>
                <p className="text-xs text-foreground-500 mt-1">实时更新</p>
              </div>
            </div>
          </div>
          <div className="lg:w-[380px] shrink-0 bg-gradient-to-br from-secondary-100/60 to-secondary-50/40 rounded-2xl p-8 flex items-center justify-center min-h-[200px] relative overflow-hidden">
            <div className="absolute top-4 right-6 w-16 h-16 rounded-2xl bg-secondary-300/40 rotate-12"></div>
            <div className="absolute bottom-6 left-4 w-20 h-20 rounded-full bg-secondary-200/30"></div>
            <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-24 h-24 rounded-3xl bg-secondary-300/20 -rotate-45"></div>
            <i className="ri-fire-line text-5xl text-secondary-500/60 relative z-10"></i>
          </div>
        </div>
      </div>
    </section>
  );
}

function TestimonialSection() {
  return (
    <section className="py-12 md:py-16 px-4 md:px-6 bg-background-50">
      <div className="max-w-[1280px] mx-auto">
        <div className="bg-foreground-950 rounded-2xl p-6 md:p-10 flex flex-col md:flex-row gap-6 md:gap-8 overflow-hidden relative">
          <div className="absolute top-0 right-10 w-32 h-32 rounded-full bg-secondary-500/10 -translate-y-1/2"></div>
          <div className="absolute bottom-0 left-10 w-24 h-24 rounded-2xl bg-accent-500/10 translate-y-1/2 rotate-45"></div>

          <div className="md:w-1/3 shrink-0 relative z-10">
            <img
              src="https://readdy.ai/api/search-image?query=Professional%20Chinese%20news%20editorial%20team%20group%20portrait%2C%20modern%20office%20setting%2C%20confident%20diverse%20team%2C%20warm%20professional%20atmosphere%2C%20editorial%20portrait%20photography%2C%20clean%20background&width=400&height=500&seq=about-team-portrait&orientation=portrait"
              alt="吃瓜爆料网团队"
              title="吃瓜爆料网 - 编辑团队"
              className="w-full aspect-[4/5] object-cover object-top rounded-xl"
              loading="lazy"
            />
          </div>

          <div className="md:w-2/3 flex flex-col justify-center relative z-10">
            <span className="text-5xl text-secondary-400 font-serif leading-none mb-4">&ldquo;</span>
            <p className="text-base md:text-lg text-background-50 leading-relaxed mb-4">
              吃瓜不是无聊消遣，而是公民监督的一种形式。当明星和网红站在聚光灯下享受流量红利时，他们的一言一行都应当接受公众审视。我们吃瓜爆料网要做的，就是让每一个瓜都吃得明明白白。
            </p>
            <div className="flex items-center gap-3">
              <span className="text-sm font-bold text-background-50">吃瓜爆料网创始人</span>
              <span className="text-xs text-background-50/50">· 资深娱乐媒体人</span>
            </div>
            <a
              href="#contact"
              className="mt-6 px-5 py-2.5 bg-secondary-500 hover:bg-secondary-600 text-background-50 font-medium rounded-full text-sm transition-colors cursor-pointer whitespace-nowrap inline-flex items-center gap-2 w-fit"
            >
              加入我们 <i className="ri-arrow-right-line text-xs"></i>
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}

function ContactSection() {
  const [formData, setFormData] = useState({ name: '', email: '', message: '' });
  const [formStatus, setFormStatus] = useState<'idle' | 'loading' | 'success' | 'error'>('idle');
  const [formError, setFormError] = useState('');

  const handleSubmit = async (e: FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    const form = e.currentTarget;
    const fd = new FormData(form);

    const honeypotVal = (fd.get('website_alt') as string || '').trim();
    if (honeypotVal) {
      setFormStatus('success');
      setFormData({ name: '', email: '', message: '' });
      setTimeout(() => setFormStatus('idle'), 3000);
      return;
    }

    if (!formData.name.trim() || !formData.email.trim() || !formData.message.trim()) return;
    if (formData.message.length > 500) {
      setFormStatus('error');
      setFormError('留言内容不能超过500字');
      return;
    }

    setFormStatus('loading');
    setFormError('');

    try {
      const params = new URLSearchParams();
      params.append('name', formData.name.trim());
      params.append('email', formData.email.trim());
      params.append('message', formData.message.trim());

      const response = await fetch('https://readdy.ai/api/form/d96bigfpg5pqhofcun5g', {
        method: 'POST',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
        body: params.toString(),
      });
      const responseText = await response.text();
      let parsed: any;
      try { parsed = JSON.parse(responseText); } catch { parsed = null; }

      if (response.ok && parsed?.code === 'OK') {
        setFormStatus('success');
        setFormData({ name: '', email: '', message: '' });
        setTimeout(() => setFormStatus('idle'), 3000);
      } else {
        const msg = parsed?.meta?.message || parsed?.message || responseText || '提交失败，请稍后重试';
        if (msg.toLowerCase().includes('spam')) {
          setFormStatus('success');
          setFormData({ name: '', email: '', message: '' });
          setTimeout(() => setFormStatus('idle'), 3000);
        } else {
          setFormStatus('error');
          setFormError(msg);
        }
      }
    } catch {
      setFormStatus('error');
      setFormError('网络错误，请稍后重试');
    }
  };

  return (
    <section id="contact" className="relative w-full min-h-[500px] md:min-h-[560px] flex items-center justify-center overflow-hidden">
      <div className="absolute inset-0 bg-gradient-to-br from-foreground-950 via-foreground-900 to-secondary-900"></div>
      <div className="absolute inset-0">
        <div className="absolute top-20 right-10 w-40 h-40 rounded-full bg-secondary-500/5 blur-3xl"></div>
        <div className="absolute bottom-20 left-10 w-52 h-52 rounded-full bg-accent-500/5 blur-3xl"></div>
      </div>

      <div className="relative z-10 w-full px-4 md:px-6 flex flex-col items-center text-center py-14 md:py-20">
        <h2 className="text-2xl md:text-4xl font-black text-background-50 font-heading mb-3">
          爆料投稿 · 商务合作
        </h2>
        <p className="text-sm md:text-base text-background-50/60 max-w-lg mb-10">
          有猛料想爆？有商务想谈？直接联系我们，快速响应
        </p>

        <form
          onSubmit={handleSubmit}
          data-readdy-form=""
          id="contact-form"
          className="w-full max-w-lg flex flex-col gap-4"
        >
          <input
            name="website_alt"
            type="text"
            tabIndex={-1}
            autoComplete="off"
            aria-hidden="true"
            readOnly
          />
          <input
            name="name"
            type="text"
            value={formData.name}
            onChange={(e) => setFormData((p) => ({ ...p, name: e.target.value }))}
            placeholder="你的名字"
            required
            className="w-full h-12 px-5 bg-background-50/10 border border-background-50/20 text-background-50 placeholder:text-background-50/40 rounded-lg text-sm focus:outline-none focus:border-primary-400"
          />
          <input
            name="email"
            type="email"
            value={formData.email}
            onChange={(e) => setFormData((p) => ({ ...p, email: e.target.value }))}
            placeholder="邮箱地址"
            required
            className="w-full h-12 px-5 bg-background-50/10 border border-background-50/20 text-background-50 placeholder:text-background-50/40 rounded-lg text-sm focus:outline-none focus:border-primary-400"
          />
          <textarea
            name="message"
            value={formData.message}
            onChange={(e) => setFormData((p) => ({ ...p, message: e.target.value }))}
            placeholder="说说你想爆料的内容或合作意向（限500字）"
            required
            maxLength={500}
            rows={4}
            className="w-full px-5 py-3 bg-background-50/10 border border-background-50/20 text-background-50 placeholder:text-background-50/40 rounded-lg text-sm focus:outline-none focus:border-primary-400 resize-none"
          />
          <p className="text-xs text-background-50/30 text-right">{formData.message.length}/500</p>

          <button
            type="submit"
            disabled={formStatus === 'loading'}
            className="h-12 px-6 bg-background-50 hover:bg-background-100 text-foreground-950 font-bold rounded-full text-sm transition-colors cursor-pointer whitespace-nowrap flex items-center justify-center gap-2 disabled:opacity-60"
          >
            {formStatus === 'loading' ? '发送中...' : (
              <>
                <span className="w-6 h-6 flex items-center justify-center bg-accent-500 rounded-full">
                  <i className="ri-mail-line text-xs text-background-50"></i>
                </span>
                立即联系
                <i className="ri-arrow-right-up-line text-sm"></i>
              </>
            )}
          </button>

          {formStatus === 'success' && (
            <p className="text-sm text-accent-300">消息已发送，我们会尽快回复！</p>
          )}
          {formStatus === 'error' && (
            <p className="text-sm text-primary-300">{formError}</p>
          )}
        </form>
      </div>
    </section>
  );
}

function FAQSection() {
  const faqs = [
    {
      q: '吃瓜爆料网的信息来源可靠吗？',
      a: '我们拥有专业的记者团队和广泛的信息网络，所有爆料均经过多方交叉验证后才发布。对于未经证实的传闻，我们会明确标注"待核实"。我们始终坚持以事实为依据，拒绝捕风捉影的虚假信息。',
    },
    {
      q: '如何向吃瓜爆料网投稿爆料？',
      a: '你可以通过本页面的"联系我们"表单提交爆料线索，或发送邮件至我们的官方邮箱。对于重要线索，我们的记者会主动与你联系核实。我们承诺对爆料人信息严格保密。',
    },
    {
      q: '吃瓜爆料网51和吃瓜爆料网入口是什么？',
      a: '吃瓜爆料网51和吃瓜爆料网入口是我们的备用访问域名和镜像站点。当主站访问量过大或遇到网络波动时，你可以通过这些入口正常浏览所有内容，确保吃瓜不中断。',
    },
    {
      q: '网站内容是否涉及侵犯隐私？',
      a: '我们严格遵守相关法律法规，所有报道内容均基于公开信息和合法途径获取的资料。对于涉及个人隐私的内容，我们会进行必要的脱敏处理。如有权利人认为内容侵权，可通过"联系我们"渠道提出申诉。',
    },
    {
      q: '如何加入吃瓜爆料网团队？',
      a: '我们长期招募娱乐记者、视频编辑、数据分析师等岗位。如果你对娱乐八卦有热情，具备相关专业能力，欢迎通过"联系我们"表单提交简历和作品集，HR会在3个工作日内回复。',
    },
  ];

  const faqSchema = {
    '@context': 'https://schema.org',
    '@type': 'FAQPage',
    mainEntity: faqs.map((faq) => ({
      '@type': 'Question',
      name: faq.q,
      acceptedAnswer: {
        '@type': 'Answer',
        text: faq.a,
      },
    })),
  };

  return (
    <section className="py-12 md:py-16 px-4 md:px-6 bg-background-50">
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(faqSchema) }}
      />
      <div className="max-w-[800px] mx-auto">
        <h2 className="text-2xl md:text-3xl font-black text-foreground-950 font-heading text-center mb-10">
          常见问题
        </h2>
        <div className="space-y-3">
          {faqs.map((faq, idx) => (
            <details
              key={idx}
              className="group bg-background-50 border border-background-200/60 rounded-lg overflow-hidden"
            >
              <summary className="px-5 py-4 text-sm md:text-base font-bold text-foreground-950 cursor-pointer list-none flex items-center justify-between gap-3 group-open:bg-background-100">
                {faq.q}
                <i className="ri-arrow-down-s-line text-foreground-400 group-open:rotate-180 transition-transform text-lg shrink-0"></i>
              </summary>
              <div className="px-5 pb-4">
                <p className="text-sm text-foreground-600 leading-relaxed">{faq.a}</p>
              </div>
            </details>
          ))}
        </div>
      </div>
    </section>
  );
}